import Vue from 'vue';
import VueWorker from 'vue-worker';

Vue.use(VueWorker);